import { createSlice } from '@reduxjs/toolkit'
import { sendBatchSearchRequest } from '../../adapters/BatchSearchAdapter';
import { transformData } from "../../helpers/batchSearchService";
import _ from 'lodash';


const getInitialState = (): BatchSearchStateType => {
  const batchSearchInitialState: BatchSearchStateType = {
    isLoading: false,
    hasError: false,
    errorMessage: "",
    searchResults: [],
    notFound: [],
    found:[],
    percentage: 0,
  };
  return batchSearchInitialState
}
// Slice
const slice = createSlice({
  name: 'batchSearchState',
  initialState: getInitialState(),
  reducers: {
    updateIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    updateError: (state, action) => {
      state.hasError = action.payload !== '';
      state.errorMessage = action.payload;
      state.isLoading = false;
    },
    updateSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    updateNotFound: (state, action) => {
      state.notFound = action.payload;
    },
    updateFound: (state, action) => {
      state.found = action.payload;
    },
    updateBatchSearchPercentage: (state, action) => {
      state.percentage = action.payload
    },
  },
});
export default slice.reducer

// Actions
const { updateIsLoading, updateError, updateSearchResults, updateNotFound,updateFound, updateBatchSearchPercentage } = slice.actions

export const searchForEquipmentsInBatch = (searchParams: string[]) => async (dispatch: any, getState: any) => {
  try {
    dispatch(clearBatchSearchData());
    dispatch(updateIsLoading(true));

    const CONCURRENT_BATCHES = 10; // Run batches of 10 concurrently
    const chunks = _.chunk(searchParams, CONCURRENT_BATCHES);
    let completedBatches = 0;
    const totalBatches = chunks.length;

    let { batchSearchStore } = getState();
    let appendingSearchResultsList: SimplifiedBatchSearchResultType[] = [...batchSearchStore.searchResults];
    let appendingNotFoundResultsList: string[] = [...batchSearchStore.notFound];
    let appendingFoundResultsList: string[] = [...batchSearchStore.found];

    const processChunk = async (chunk: string[]) => {
      try {
        const res = await sendBatchSearchRequest(chunk);

        let notFound: string[] = [];
        let found: string[] = [];
        let transformedData: SimplifiedBatchSearchResultType[] = [];

        if (res.data?.equipmentDetails?.length > 0) {
          transformedData = transformData(res.data.equipmentDetails);
        }

        // Use only API-provided failed/succeeded
        notFound = [...(res.data.failed || [])];
        found = [...(res.data.succeeded || [])];

        // Append results
        appendingSearchResultsList = appendingSearchResultsList.concat(transformedData);
        appendingNotFoundResultsList = appendingNotFoundResultsList.concat(notFound);
        appendingFoundResultsList = appendingFoundResultsList.concat(found);

        // Dispatch updated state
        dispatch(updateSearchResults(appendingSearchResultsList));
        dispatch(updateNotFound(appendingNotFoundResultsList));
        dispatch(updateFound(appendingFoundResultsList));

      } catch (err: any) {
        console.error("Batch failed:", err);
        dispatch(updateError(err.message));
      } finally {
        completedBatches++;
        const percentage = Math.ceil((completedBatches / totalBatches) * 100);
        dispatch(updateBatchSearchPercentage(percentage));
      }
    };

    const runInParallelBatches = async () => {
      let index = 0;

      const runNext = async (): Promise<void> => {
        if (index >= chunks.length) return;
        const currentChunk = chunks[index++];
        await processChunk(currentChunk);
        return runNext();
      };

      const concurrentRunners = Array(Math.min(CONCURRENT_BATCHES, chunks.length))
        .fill(0)
        .map(() => runNext());

      await Promise.all(concurrentRunners);
    };

    await runInParallelBatches();

    dispatch(updateIsLoading(false));
  } catch (e: any) {
    dispatch(updateError(e.message));
    return console.error(e);
  }
};

export const clearNotfound = () => async (dispatch: any) => {
  dispatch(updateNotFound([]));
}

export const clearBatchSearchData = () => async (dispatch: any) => {
  dispatch(updateSearchResults([]));
  dispatch(updateNotFound([]));
  dispatch(updateFound([]));
  dispatch(updateBatchSearchPercentage(0));
}